if (!customElements.get('quiz-form')) {
  class QuizForm extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-block-type]'));
      this.progress = this.querySelector('[data-quiz-progress]');
      this.questionsNumber = this.querySelector('[data-quiz-question]');
      this.backButton = this.querySelector('[data-quiz-back]');
      this.continueButton = this.querySelector('[data-quiz-continue]');

      if (!this.steps.length) return;

      this.currentIndex = 0;

      this.steps.forEach((step) => this.bindStep(step));

      this.backButton?.addEventListener('click', () => this.goBack());
      this.continueButton?.addEventListener('click', () => {
        if (this.continueButton.disabled) return;
        this.goNext();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      this.showStep(0);
    }

    bindStep(step) {
      if (step.dataset.blockType !== 'quiz-step') return;

      const options = Array.from(step.querySelectorAll('[data-quiz-option]'));
      const multiple = step.dataset.quizType === 'multiple';

      options.forEach((option) => {
        option.addEventListener('click', () => {
          if (multiple) {
            const selected = option.classList.toggle('is-selected');
            option.setAttribute('aria-pressed', String(selected));
            this.updateNav();
          } else {
            options.forEach((other) => {
              other.classList.remove('is-selected');
              other.setAttribute('aria-pressed', 'false');
            });
            option.classList.add('is-selected');
            option.setAttribute('aria-pressed', 'true');
            this.goNext();
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    isQuizStep(step) {
      return step.dataset.blockType === 'quiz-step';
    }

    isMultiple(step) {
      return this.isQuizStep(step) && step.dataset.quizType === 'multiple';
    }

    hasSelectedOption(step) {
      return Array.from(step.querySelectorAll('[data-quiz-option]')).some((option) =>
        option.classList.contains('is-selected')
      );
    }

    updateProgress() {
      if (this.questionsNumber) this.questionsNumber.textContent = this.currentIndex + 1;
      if (!this.progress) return;
      this.progress.max = this.steps.length;
      this.progress.value = this.currentIndex + 1;
    }

    updateNav() {
      const step = this.steps[this.currentIndex];
      const isLast = this.currentIndex === this.steps.length - 1;

      if (this.backButton) this.backButton.hidden = this.currentIndex === 0;

      if (this.continueButton) {
        const isFirstSingleStep = this.currentIndex === 0 && this.isQuizStep(step) && !this.isMultiple(step);
        const showContinue = this.isQuizStep(step)
          ? this.isMultiple(step) || (this.hasSelectedOption(step) && !isFirstSingleStep)
          : !isLast;
        this.continueButton.hidden = !showContinue;
        this.continueButton.disabled = this.isQuizStep(step) ? !this.hasSelectedOption(step) : false;
      }
    }

    showStep(index) {
      this.steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === index);
      });
      this.currentIndex = index;
      this.updateProgress();
      this.updateNav();
    }

    goNext() {
      if (this.currentIndex < this.steps.length - 1) this.showStep(this.currentIndex + 1);
    }

    goBack() {
      if (this.currentIndex > 0) this.showStep(this.currentIndex - 1);
    }
  }

  customElements.define('quiz-form', QuizForm);
}
